import { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { TState } from 'redux/config/root-types'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { Actions_Users } from 'redux/modules/users/Actions'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'

export const useResendBill = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.resendBill)

  const { id } = useSelector(({ modals }: TState) => modals.data)

  const onSubmit = useCallback(() => {
    dispatch(Actions_CurrentUser.saga.getBill(id))
    dispatch(Actions_Modals.store.hideModal())
  }, [dispatch, id])

  const onCancel = useCallback(() => dispatch(Actions_Modals.store.hideModal()), [dispatch])

  return { t, onSubmit, onCancel }
}
